import { getMediaType, getEmbedUrl } from '../utils/mediaUtils';
import { MediaRenderer } from './MediaRenderers';

interface MediaPreviewProps {
  url: string;
  onClick?: () => void;
}

export const MediaPreview = ({ url, onClick }: MediaPreviewProps) => {
  const mediaType = getMediaType(url);
  const embedUrl = getEmbedUrl(url, mediaType);

  return (
    <MediaRenderer
      url={url}
      embedUrl={embedUrl}
      mediaType={mediaType}
      onClick={onClick}
      variant="preview"
    />
  );
};
